"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.addOebbDialogModalDefaultStyles = exports.initDialogsModalWithTemplate = exports.OebbDialogModal = void 0;
var OebbDialogModal = /** @class */ (function () {
    function OebbDialogModal(_a) {
        var contentAsHtml = _a.contentAsHtml, _b = _a.showOnCreation, showOnCreation = _b === void 0 ? false : _b, _c = _a.showCallback, showCallback = _c === void 0 ? null : _c, _d = _a.hideCallback, hideCallback = _d === void 0 ? null : _d, _e = _a.ariaLabelledBy, ariaLabelledBy = _e === void 0 ? null : _e, _f = _a.hideRootScrollbars, hideRootScrollbars = _f === void 0 ? true : _f;
        this.isOpen = false;
        this.contentAsHtml = contentAsHtml;
        this.showOnCreation = showOnCreation;
        this.showCallback = showCallback;
        this.hideCallback = hideCallback;
        this.ariaLabelledBy = ariaLabelledBy;
        this.hideRootScrollbars = hideRootScrollbars;
        this.initDom();
        this.initListeners();
        this.setContentAsHtml(this.contentAsHtml);
        if (this.showOnCreation)
            this.show();
    }
    OebbDialogModal.prototype.initDom = function () {
        this.overlay = document.createElement('div');
        this.overlay.classList.add('oebb-dm-overlay');
        this.overlay.classList.add('js-oebb-dm-overlay');
        this.overlay.classList.add('oebb-dm-overlay--hidden');
        this.overlay.hidden = true;
        this.dialog = document.createElement('div');
        this.dialog.classList.add('oebb-dm-dialog');
        this.dialog.classList.add('js-oebb-dm-dialog');
        this.dialog.setAttribute('role', 'dialog');
        this.dialog.setAttribute('aria-modal', 'true'); // Tell screenreaders that content behind the modal is not interactive
        if (this.ariaLabelledBy)
            this.dialog.setAttribute('aria-labelledby', this.ariaLabelledBy); // Tell screenreaders the ID of the title element
        this.btnClose = document.createElement('button');
        this.btnClose.classList.add('oebb-dm-btn-close');
        this.btnClose.classList.add('js-oebb-dm-btn-close');
        this.btnClose.setAttribute('aria-label', 'Close');
        this.btnClose.innerHTML = "<span aria-hidden=\"true\">&times;</span>";
        this.overlay.appendChild(this.btnClose);
        this.overlay.appendChild(this.dialog);
        document.body.appendChild(this.overlay);
    };
    OebbDialogModal.prototype.initListeners = function () {
        var _this = this;
        var overlayMouseDownTarget;
        this.btnClose.addEventListener('click', function () {
            _this.hide();
        });
        this.overlay.addEventListener('mousedown', function (e) {
            overlayMouseDownTarget = e.target;
        });
        this.overlay.addEventListener('mouseup', function () {
            if (overlayMouseDownTarget && overlayMouseDownTarget.classList.contains('js-oebb-dm-overlay')) {
                _this.hide();
            }
        });
        document.addEventListener('keyup', function (e) {
            if (e.keyCode != 27)
                return;
            var overlay = document.querySelector('.js-oebb-dm-overlay');
            if (overlay)
                _this.hide();
        });
        this.handleFirstFocusableElementHandler = this.handleFirstFocusableElement.bind(this);
        this.handleLastFocusableElementHandler = this.handleLastFocusableElement.bind(this);
    };
    OebbDialogModal.prototype.setContentAsHtml = function (contentAsHtml) {
        this.contentAsHtml = contentAsHtml;
        this.dialog.innerHTML = contentAsHtml;
        var childNodes = this.getFocusableChildNodes();
        if (!Boolean(childNodes.length))
            return;
        this.firstFocusableElement = childNodes[0];
        this.lastFocusableElement = childNodes[childNodes.length - 1];
        this.setFirstFocusableElement(this.firstFocusableElement);
        this.setLastFocusableElement(this.lastFocusableElement);
    };
    OebbDialogModal.prototype.setFirstFocusableElement = function (firstFocusableElement) {
        if (this.firstFocusableElement)
            this.firstFocusableElement.removeEventListener('keydown', this.handleFirstFocusableElementHandler);
        this.firstFocusableElement = firstFocusableElement;
        this.firstFocusableElement.addEventListener('keydown', this.handleFirstFocusableElementHandler);
    };
    OebbDialogModal.prototype.setLastFocusableElement = function (lastFocusableElement) {
        if (this.lastFocusableElement)
            this.lastFocusableElement.removeEventListener('keydown', this.handleLastFocusableElementHandler);
        this.lastFocusableElement = lastFocusableElement;
        this.lastFocusableElement.addEventListener('keydown', this.handleLastFocusableElementHandler);
    };
    OebbDialogModal.prototype.handleFirstFocusableElement = function (e) {
        if (e.shiftKey && e.keyCode == 9) {
            e.preventDefault();
            this.focusLastFocusableElement();
        }
    };
    OebbDialogModal.prototype.handleLastFocusableElement = function (e) {
        if (e.keyCode == 9 && !(e.shiftKey && e.keyCode == 9)) {
            e.preventDefault();
            this.focusFirstFocusableElement();
        }
    };
    OebbDialogModal.prototype.focusFirstFocusableElement = function () {
        if (this.firstFocusableElement)
            this.firstFocusableElement.focus();
    };
    OebbDialogModal.prototype.focusLastFocusableElement = function () {
        if (this.lastFocusableElement)
            this.lastFocusableElement.focus();
    };
    OebbDialogModal.prototype.focusLastDocumentElement = function () {
        if (this.lastElement)
            this.lastElement.focus();
    };
    OebbDialogModal.prototype.show = function () {
        this.lastElement = document.activeElement;
        if (this.hideRootScrollbars) {
            document.documentElement.style.overflow = 'hidden';
            document.body.style.overflow = 'hidden';
        }
        this.overlay.classList.remove('oebb-dm-overlay--hidden');
        this.overlay.hidden = false;
        this.isOpen = true;
        this.focusFirstFocusableElement();
        if (this.showCallback)
            this.showCallback();
    };
    OebbDialogModal.prototype.hide = function () {
        if (this.hideRootScrollbars) {
            document.documentElement.style.overflow = 'auto';
            document.body.style.overflow = 'auto';
        }
        this.overlay.classList.add('oebb-dm-overlay--hidden');
        this.overlay.hidden = true;
        this.isOpen = false;
        this.focusLastDocumentElement();
        if (this.hideCallback)
            this.hideCallback();
    };
    OebbDialogModal.prototype.isActive = function () {
        return this.isOpen;
    };
    OebbDialogModal.prototype.remove = function () {
        this.overlay.parentNode.removeChild(this.overlay);
    };
    OebbDialogModal.prototype.getFocusableChildNodes = function () {
        var _this = this;
        var focusableSelector = 'button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])';
        var childNodesOverlay = Array.prototype.slice.call(this.overlay.querySelectorAll(focusableSelector));
        var childNodesDialog = Array.prototype.slice.call(this.dialog.querySelectorAll(focusableSelector));
        var childNodesComponents = [];
        var components = Array.prototype.slice.call(this.dialog.querySelectorAll('*')).filter(function (element) {
            if (element.tagName.indexOf('-') > -1)
                return element;
        });
        for (var _i = 0, components_1 = components; _i < components_1.length; _i++) {
            var component = components_1[_i];
            if (!!component.shadowRoot) {
                childNodesComponents = childNodesComponents.concat(Array.prototype.slice.call(component.shadowRoot.querySelectorAll(focusableSelector)));
            }
        }
        return childNodesOverlay
            .concat(childNodesDialog)
            .concat(childNodesComponents)
            .filter(function (node) {
            return _this.isFocusable(node);
        });
    };
    OebbDialogModal.prototype.isFocusable = function (element) {
        if (element.tabIndex > 0 || (element.tabIndex === 0 && element.getAttribute('tabIndex') !== null))
            return true;
        if (element.disabled)
            return false;
        switch (element.nodeName) {
            case 'A':
                return !!element.href && element.rel != 'ignore';
            case 'INPUT':
                return element.type != 'hidden' && element.type != 'file';
            case 'BUTTON':
            case 'SELECT':
            case 'TEXTAREA':
                return true;
            default:
                return false;
        }
    };
    return OebbDialogModal;
}());
exports.OebbDialogModal = OebbDialogModal;
function initDialogsModalWithTemplate() {
    var dialogsModal = [];
    if (document.querySelector('[data-oebb-dm]')) {
        var dialogModalTriggers = document.querySelectorAll('[data-oebb-dm]');
        var _loop_1 = function (i) {
            var target = dialogModalTriggers[i].dataset.oebbDm;
            if (document.querySelector(target)) {
                var template = document.querySelector(target);
                var templateClone = template.content.cloneNode(true);
                var ariaLabelledBy = template.dataset.ariaLabelledby;
                var tempDiv = document.createElement('div');
                tempDiv.appendChild(templateClone);
                var dialogModal_1 = new OebbDialogModal({
                    contentAsHtml: tempDiv.innerHTML,
                    ariaLabelledBy: ariaLabelledBy,
                });
                dialogsModal.push(dialogModal_1);
                dialogModalTriggers[i].addEventListener('click', function (e) {
                    e.preventDefault();
                    dialogModal_1.show();
                });
            }
        };
        for (var i = 0; i < dialogModalTriggers.length; i++) {
            _loop_1(i);
        }
    }
    return dialogsModal;
}
exports.initDialogsModalWithTemplate = initDialogsModalWithTemplate;
function addOebbDialogModalDefaultStyles(tint) {
    if (tint === void 0) { tint = '#e2002a'; }
    if (document.querySelector('#js-oebb-dm-styles'))
        return;
    var style = document.createElement('style');
    style.id = 'js-oebb-dm-styles';
    style.innerHTML = "\n        .oebb-dm-overlay {\n            position: fixed;\n            top: 0;\n            right: 0;\n            bottom: 0;\n            left: 0;\n            z-index: 100;\n\n            display: block;\n            padding: 50px 15px 20px;\n            overflow-y: auto;\n\n            background-color: rgba(0, 0, 0, 0.75);\n        }\n\n        .oebb-dm-overlay[hidden],\n        .oebb-dm-overlay--hidden {\n            display: none;\n        }\n\n        .oebb-dm-btn-close {\n            position: absolute;\n            top: 5px;\n            right: 5px;\n\n            display: inline-block;\n            width: 35px;\n            height: 35px;\n\n            background: transparent;\n            border: none;\n            cursor: pointer;\n\n            color: #ffffff;\n            font-size: 35px;\n        }\n\n        .oebb-dm-dialog {\n            position: relative;\n\n            display: block;\n            width: 100%;\n            max-width: 900px;\n            margin: 0 auto 50px;\n\n            background-color: #ffffff;\n        }\n\n        .oebb-dm-dialog__container {\n            padding: 1em;\n        }\n\n        .oebb-dm-template {\n            display: none;\n        }\n    ";
    document.head.appendChild(style);
}
exports.addOebbDialogModalDefaultStyles = addOebbDialogModalDefaultStyles;
